import React from 'react';
import './App.css'; // Zaimportuj plik CSS do stylizacji
import IonIcon from '@reacticons/ionicons';
import { Link } from 'react-router-dom';
const Opinions = () => {
  return (
    <div className="Opinions">
      <h2>Opinie o mnie klientów z forum-krakow.pl </h2>
      <div className="Opinion">
        <div className="MessageBubble">
          <IonIcon size={20} className="UserIcon" name="person" />
          <div className="MessageContent">
            Polecam fachowca od naprawy pralek pana Przemysława Sikorę, nr tel. 513 034 180. Dziś był u nas w domu - pomógł nam błyskawicznie, a kwota, którą podał do zapłaty, była bardzo mała. Uczciwy, pomocny Pan. Oby więcej takich osób!!! Polecam gorąco z Krakowa.
          </div>
        </div>
      </div>

      <div className="Opinion">
        <div className="MessageBubble">
          <IonIcon size={20} className="UserIcon" name="person" />
          <div className="MessageContent">
            Polecam pana Przemysława. Wiem, że o nim już pisaliście i dzięki Waszym wpisom do niego trafiłam, ale chcę od siebie napisać, że naprawił moją pralkę w około pół godziny, miał przy sobie niezbędne części zamienne i przyjemnie było patrzeć, jak pracuje. Wiedział, co robi, znał budowę pralki. Miałam wrażenie, że mógłby ją naprawić z zamkniętymi oczami. Kulturalny, słowny, terminowy. Pralka hula, aż miło patrzeć i słuchać. Uzgodniona wstępnie cena nie uległa zmianie i była niewysoka. Polecam.
          </div>
        </div>
      </div>

      <div className="Opinion">
        <div className="MessageBubble">
          <IonIcon size={20} className="UserIcon" name="person" />
          <div className="MessageContent">
            Też korzystałem z usług tego pana. Naprawdę fachowiec godny polecenia. Naprawił pralkę w 30 minut, a koszt to 50 zł.
          </div>
        </div>
      </div>

      <div className="Opinion">
        <div className="MessageBubble">
          <IonIcon size={20} className="UserIcon" name="person" />
          <div className="MessageContent">
            A ja bardzo dziękuję za Wasze opinie. Potrzebowałam ostatnio mechanika do pralki i trafiłam na to forum. Zadzwoniłam do Pana Przemka i powiem Wam, że mile byłam zaskoczona. Nie tylko wycenił naprawę już przez telefon, a cena się nie zmieniła, ale również w porównaniu z innymi serwisami (dzwoniłam orientacyjnie), ceny ma naprawdę niskie. Pan Przemek przyjechał punktualnie, był miły i sympatyczny. Szybko rozwiązał problem. Jestem mega zadowolona. I serdecznie polecam. Oczywiście, mowa o mechaniku z numeru 513034180. Pełen profesjonalizm.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Opinions;
